import { useState } from 'react';
import { featuredMelons } from '@/mocks/gossip';

const toneMap: Record<string, string> = {
  primary: 'bg-primary-500 text-background-50',
  accent: 'bg-accent-500 text-background-50',
};

export default function SpeedFeed() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});
  const [refreshed, setRefreshed] = useState(false);

  return (
    <section id="speed" className="bg-background-50 py-12 md:py-20">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="flex items-center gap-2 text-sm font-bold text-primary-600">
              <i className="ri-flashlight-fill" />
              新瓜速递 · 前线实时更新
            </p>
            <h2 className="mt-2 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
              刚发酵的瓜，最新动态都在这里
            </h2>
            <p className="mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
              事件刚抬头就上首页，聊天记录、截图与前后动态一并归档，按时间线排好给你递上手。
            </p>
          </div>
          <button
            type="button"
            onClick={() => setRefreshed(true)}
            className="flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-full border border-primary-200 bg-primary-50 px-5 py-2.5 text-sm font-bold text-primary-700 transition hover:bg-primary-100"
          >
            <i className={`${refreshed ? 'ri-refresh-line animate-spin' : 'ri-refresh-line'} text-base`} />
            {refreshed ? '已刷新 · 新瓜置顶' : '刷新速递'}
          </button>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-2">
          {featuredMelons.map((m) => (
            <article
              key={m.id}
              className="group overflow-hidden rounded-3xl border border-background-200 bg-background-50 transition hover:border-primary-200"
            >
              <div className="relative overflow-hidden">
                <img
                  src={m.cover}
                  alt={`${m.cat} ${m.title}`}
                  title={`91吃瓜 ${m.title}`}
                  className="aspect-[3/2] w-full object-cover transition duration-500 group-hover:scale-[1.04]"
                />
                <span className={`absolute left-4 top-4 flex h-9 w-9 items-center justify-center rounded-full text-sm font-black text-background-50 ${toneMap[m.tagTone]}`}>
                  {m.tag}
                </span>
                <span className="absolute bottom-4 left-4 flex items-center gap-1.5 rounded-full bg-foreground-950/60 px-3 py-1 text-xs font-bold text-background-50 backdrop-blur">
                  <i className={`${m.catIcon} text-sm`} />
                  {m.cat}
                </span>
              </div>

              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg font-black leading-snug text-foreground-950 md:text-xl">
                  {m.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                  {m.summary}
                </p>

                <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <span className="flex h-6 w-6 items-center justify-center rounded-full bg-secondary-100 text-xs font-bold text-secondary-700">
                      {m.author.replace('搬瓜员·', '').slice(0, 1)}
                    </span>
                    {m.author} · {m.time}
                  </span>
                  <div className="flex items-center gap-4">
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-fill text-primary-500" />
                      {m.heat}万热度
                    </span>
                    <button
                      type="button"
                      onClick={() => setLiked((s) => ({ ...s, [m.id]: !s[m.id] }))}
                      className={`flex items-center gap-1 transition ${liked[m.id] ? 'text-primary-600' : 'hover:text-primary-600'}`}
                      aria-label="跟进"
                    >
                      <i className={`${liked[m.id] ? 'ri-heart-fill' : 'ri-heart-line'} text-sm`} />
                      {m.comments}
                    </button>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 text-center">
          <a
            href="#commentBox"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 py-3 text-sm font-bold text-foreground-700 transition hover:border-primary-300 hover:text-primary-600"
          >
            查看更多最新瓜
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}